import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Volume2, X, Radio } from "lucide-react";

// Full-screen court call-out for a side monitor when a match is staged.
export default function CallScreen({ call, onClose, onAnnounce }) {
  useEffect(() => {
    if (!call) return;
    const t = setTimeout(onClose, 12000);
    return () => clearTimeout(t);
  }, [call, onClose]);

  return (
    <AnimatePresence>
      {call && (
        <motion.div
          data-testid="call-screen"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] cyber-grid grain flex flex-col items-center justify-center px-6"
          style={{ background: "var(--bg)" }}
        >
          <div className="absolute inset-0" style={{ background: "radial-gradient(900px 500px at 50% 20%, var(--glow), transparent 70%)" }} />
          <button data-testid="call-screen-close" onClick={onClose}
            className="absolute top-6 right-6 z-10 w-12 h-12 rounded-full glass flex items-center justify-center hover:scale-110 transition-transform">
            <X className="w-6 h-6 text-primary-c" />
          </button>

          <motion.div initial={{ scale: 0.9, y: 20 }} animate={{ scale: 1, y: 0 }} transition={{ type: "spring", stiffness: 140, damping: 16 }}
            className="relative z-10 text-center max-w-5xl w-full">
            <span className="inline-flex items-center gap-2 text-sm sm:text-base tracking-[0.35em] uppercase font-bold text-primary-c pulse-ring glass rounded-full px-5 py-2">
              <Radio className="w-4 h-4" /> Now Staging
            </span>
            <h1 className="font-display font-black tracking-tighter text-5xl sm:text-7xl lg:text-8xl mt-8 text-primary-c">
              {call.court_name}
            </h1>

            <div className="mt-12 grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-2 sm:gap-8">
              <div data-testid="call-team-a" className="min-w-0">
                <div className="text-xs sm:text-sm tracking-[0.3em] uppercase font-bold mb-3" style={{ color: "var(--text-2)" }}>Team A</div>
                {call.teamAnames.map((n, i) => (
                  <div key={i} className="font-display font-bold text-lg sm:text-4xl lg:text-5xl truncate">{n}</div>
                ))}
              </div>
              <div className="font-display font-black text-xl sm:text-5xl text-primary-c shrink-0">VS</div>
              <div data-testid="call-team-b" className="min-w-0">
                <div className="text-xs sm:text-sm tracking-[0.3em] uppercase font-bold mb-3" style={{ color: "var(--text-2)" }}>Team B</div>
                {call.teamBnames.map((n, i) => (
                  <div key={i} className="font-display font-bold text-lg sm:text-4xl lg:text-5xl truncate">{n}</div>
                ))}
              </div>
            </div>

            <button data-testid="call-screen-announce" onClick={onAnnounce}
              className="btn-glow rounded-full px-7 py-3.5 font-bold text-lg mt-14 inline-flex items-center gap-3">
              <Volume2 className="w-5 h-5" /> Announce Again
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
